module.exports = __webpack_public_path__ + "static/media/green_animal_birds.8e36f5dc.png";